export default "__VITE_ASSET__79972d1c__"